var map = {
	"./HVU-icon-transparent-fff.svg": "1ae1",
	"./HVU-icon-transparent.svg": "ceb5",
	"./HVU_Logo.svg": "3746",
	"./answerinput_icon.svg": "0dfa",
	"./circuits_library.svg": "3b7c",
	"./coding_icon.svg": "9aa7",
	"./course_import_temp.svg": "1e86",
	"./hvu_practice_icon.svg": "6748",
	"./matlab_library.svg": "afd4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";